/* @flow */
import { List, Map } from 'immutable';

/* Remove special characters from Threat Actor terms */
const normalizeText = (text: string): string => {
  return text
    .replace(/%s/g, ' ')
    .replace(/\\/g, '');
};

/* Normalizes Threat Actor text and converts Aliases to a List */
export const normalizeThreatActor = (threatActor: any): Map<string, any> => {
  return threatActor.has('aliases')
    ? threatActor.update('aliases', a => a.toList().map(normalizeText))
    : threatActor.set('aliases', List())
    .update('name', n => normalizeText(n));
};

/* Normalize Threat Actor aliases from a List to a comma-separated-string
 * for rendering */
export const normalizeAliases = (aliases: List<string>): string => {
  const aliasString = aliases
    .toArray()
    .join(', ');
  return aliasString ? aliasString : '(no aliases)';
};



// WEBPACK FOOTER //
// ./src/app/modules/threat-actors/utils.js